(function () {
  'use strict';

  var root = document.documentElement;
  var mq = window.matchMedia('(max-width: 767px)');
  var resizeObserver = null;
  var observedPromo = null;
  var observedHeader = null;
  var cartObserver = null;
  var observedCartList = null;
  var styleId = 'obfw-dynamic-mobile-header-style';

  function ensureStyle() {
    if (document.getElementById(styleId)) return;

    var style = document.createElement('style');
    style.id = styleId;
    style.textContent = [
      '/* ===== OBFW cart drawer visual system ===== */',
      '#cart{background:#FCFAF2!important;color:#4B403A!important;}',
      '#cart ul[data-money-format]{background:#FCFAF2!important;box-sizing:border-box!important;}',
      '#cart li{border-color:#DED4C8!important;box-sizing:border-box!important;}',
      '#cart .obfw-cart-head{position:relative!important;min-height:82px!important;padding:18px 58px 16px 20px!important;background:#F3EEE4!important;border-bottom:1px solid #DED4C8!important;}',
      '#cart .obfw-cart-heading{display:block!important;margin:0!important;padding:0!important;}',
      '#cart .obfw-cart-eyebrow{display:block!important;margin:0 0 4px!important;color:#535E4B!important;font-size:10px!important;line-height:1.2!important;font-weight:700!important;letter-spacing:.14em!important;text-transform:uppercase!important;}',
      '#cart .obfw-cart-title{display:block!important;margin:0!important;color:#4B403A!important;font-size:23px!important;line-height:1.15!important;font-weight:500!important;letter-spacing:-.02em!important;}',
      '#cart .obfw-cart-count{display:block!important;margin:5px 0 0!important;color:#756B64!important;font-size:12px!important;line-height:1.3!important;font-weight:400!important;}',
      '#cart .obfw-cart-head>.continue{position:absolute!important;top:18px!important;right:18px!important;width:42px!important;height:42px!important;min-width:42px!important;min-height:42px!important;margin:0!important;padding:0!important;border:1px solid #D8CCBE!important;border-radius:999px!important;background:#FFFEFB!important;display:flex!important;align-items:center!important;justify-content:center!important;color:#4B403A!important;text-decoration:none!important;box-sizing:border-box!important;}',
      '#cart .obfw-cart-head>.continue:hover{background:#EDE8DD!important;border-color:#C9BCAA!important;color:#4B403A!important;}',
      '#cart .cart_item{background:#FCFAF2!important;}',
      '#cart .cart_item .cart_image{background:#FFFEFB!important;border:1px solid #E5DDD2!important;border-radius:8px!important;box-sizing:border-box!important;overflow:hidden!important;}',
      '#cart .cart_item .cart_image img{object-fit:contain!important;}',
      '#cart .cart_item .item_info{color:#4B403A!important;font-weight:500!important;}',
      '#cart .cart_item .item_info .line-item{margin-top:3px!important;color:#756B64!important;font-size:12px!important;line-height:1.35!important;font-weight:400!important;}',
      '#cart .cart_item .item_info .price{margin-top:6px!important;color:#4B403A!important;font-weight:700!important;}',
      '#cart .cart_item>.mm-counter{display:inline-flex!important;align-items:center!important;justify-content:center!important;background:#FFFEFB!important;border:1px solid #D8CCBE!important;border-radius:999px!important;overflow:hidden!important;box-shadow:none!important;}',
      '#cart .cart_item>.mm-counter .minus,#cart .cart_item>.mm-counter .plus{display:inline-flex!important;align-items:center!important;justify-content:center!important;width:38px!important;height:38px!important;min-width:38px!important;min-height:38px!important;margin:0!important;background:#F3EEE4!important;color:#4B403A!important;cursor:pointer!important;box-sizing:border-box!important;}',
      '#cart .cart_item>.mm-counter .minus:hover,#cart .cart_item>.mm-counter .plus:hover{background:#DCE2D7!important;color:#35402F!important;}',
      '#cart .cart_item>.mm-counter input.quantity{width:42px!important;height:38px!important;min-width:42px!important;margin:0!important;padding:0 4px!important;border:0!important;border-left:1px solid #D8CCBE!important;border-right:1px solid #D8CCBE!important;border-radius:0!important;background:#FFFEFB!important;color:#4B403A!important;text-align:center!important;font-size:14px!important;line-height:38px!important;box-shadow:none!important;}',
      '#cart .mm-label{background:#F3EEE4!important;border-top:1px solid #DED4C8!important;border-bottom:0!important;padding:16px 20px!important;}',
      '#cart .mm-label>a,#cart .mm-label>a strong{color:#4B403A!important;font-size:12px!important;line-height:1.2!important;font-weight:700!important;letter-spacing:.08em!important;text-transform:uppercase!important;text-decoration:none!important;}',
      '#cart .mm-label .mm-counter.price,#cart .mm-label .money{color:#4B403A!important;font-size:19px!important;font-weight:700!important;letter-spacing:-.01em!important;}',
      '#cart .mm-subtitle.clearfix{background:#F3EEE4!important;border-top:0!important;}',
      '#cart .mm-subtitle.clearfix .action_button{font-weight:600!important;letter-spacing:0!important;text-transform:none!important;border-radius:8px!important;box-shadow:none!important;}',
      '#cart .empty_cart{padding:42px 24px!important;color:#756B64!important;text-align:center!important;font-size:15px!important;line-height:1.6!important;background:#FCFAF2!important;}',

      '@media only screen and (min-width:768px){',
        '#cart .obfw-cart-head{min-height:78px!important;padding:17px 54px 14px 18px!important;}',
        '#cart .obfw-cart-title{font-size:21px!important;}',
        '#cart .cart_item{padding-top:14px!important;padding-bottom:14px!important;}',
        '#cart .cart_item .cart_image{border-radius:7px!important;}',
        '#cart .mm-label{padding-left:18px!important;padding-right:18px!important;}',
      '}',

      '@media only screen and (max-width:767px){',
        'html body:has(.obfw-pdp) #shopify-section-header{position:static!important;top:auto!important;}',
        'html body .promo_banner,html body:has(.obfw-pdp) #shopify-section-header .promo_banner{position:fixed!important;top:0!important;left:0!important;right:0!important;width:100%!important;height:auto!important;z-index:1002!important;}',
        'html body:has(.obfw-pdp) #shopify-section-header .promo_banner .promo_banner__link,html body:has(.obfw-pdp) #shopify-section-header .promo_banner .promo_banner__text{height:auto!important;}',
        'html body #header.mobile-header,html body #header.mm-fixed-top.Fixed.mobile-header,html body:has(.obfw-pdp) #shopify-section-header #header.mobile-header,html body:has(.obfw-pdp) #shopify-section-header #header.mm-fixed-top.Fixed.mobile-header{position:fixed!important;top:var(--obfw-mobile-promo-height,44px)!important;left:0!important;right:0!important;width:100%!important;z-index:1001!important;}',
        'html body div.content,html body:has(.obfw-pdp) div.content{padding-top:var(--obfw-mobile-header-stack,93px)!important;}',
        'html.mm-opened body .promo_banner,html.mm-opening body .promo_banner,html.mm-opened body #header.mobile-header,html.mm-opening body #header.mobile-header,html.mm-opened body #header.mm-fixed-top.Fixed.mobile-header,html.mm-opening body #header.mm-fixed-top.Fixed.mobile-header{z-index:0!important;}',

        'html.mm-opened body #cart,html.mm-opening body #cart{position:fixed!important;top:0!important;right:0!important;bottom:0!important;left:0!important;width:100vw!important;min-width:100vw!important;max-width:100vw!important;height:100vh!important;height:100dvh!important;min-height:100vh!important;min-height:100dvh!important;max-height:100vh!important;max-height:100dvh!important;margin:0!important;border:0!important;border-radius:0!important;box-shadow:none!important;transform:none!important;background:#FCFAF2!important;z-index:99999!important;overflow-x:hidden!important;overflow-y:auto!important;}',
        'html.mm-opened body #cart .mm-panels,html.mm-opening body #cart .mm-panels,html.mm-opened body #cart .mm-panel,html.mm-opening body #cart .mm-panel{width:100%!important;max-width:none!important;min-width:0!important;height:auto!important;min-height:100%!important;margin:0!important;padding:0!important;background:#FCFAF2!important;box-sizing:border-box!important;}',
        'html.mm-opened body #cart ul[data-money-format],html.mm-opening body #cart ul[data-money-format]{display:flex!important;flex-direction:column!important;width:100%!important;min-height:100vh!important;min-height:100dvh!important;margin:0!important;padding:0!important;box-sizing:border-box!important;background:#FCFAF2!important;}',
        'html.mm-opened body #cart .obfw-cart-head,html.mm-opening body #cart .obfw-cart-head{position:sticky!important;top:0!important;z-index:4!important;min-height:88px!important;padding:20px 64px 18px 20px!important;background:#F3EEE4!important;}',
        'html.mm-opened body #cart .obfw-cart-head>.continue,html.mm-opening body #cart .obfw-cart-head>.continue{top:20px!important;right:18px!important;width:44px!important;height:44px!important;min-width:44px!important;min-height:44px!important;}',
        'html.mm-opened body #cart .obfw-cart-title,html.mm-opening body #cart .obfw-cart-title{font-size:24px!important;}',

        'html.mm-opened body #cart .cart_item,html.mm-opening body #cart .cart_item{display:flex!important;flex-wrap:wrap!important;align-items:flex-start!important;width:100%!important;margin:0!important;padding:18px 20px 20px!important;background:#FCFAF2!important;border-bottom:1px solid #DED4C8!important;}',
        'html.mm-opened body #cart .cart_item>a,html.mm-opening body #cart .cart_item>a{order:1!important;width:100%!important;min-width:0!important;margin:0!important;padding:0!important;display:grid!important;grid-template-columns:88px minmax(0,1fr)!important;gap:14px!important;align-items:start!important;box-sizing:border-box!important;color:#4B403A!important;text-decoration:none!important;}',
        'html.mm-opened body #cart .cart_item .cart_image,html.mm-opening body #cart .cart_item .cart_image{float:none!important;width:88px!important;height:112px!important;max-width:88px!important;margin:0!important;padding:6px!important;display:flex!important;align-items:center!important;justify-content:center!important;background:#FFFEFB!important;}',
        'html.mm-opened body #cart .cart_item .cart_image img,html.mm-opening body #cart .cart_item .cart_image img{display:block!important;width:100%!important;height:100%!important;max-width:76px!important;max-height:100px!important;object-fit:contain!important;}',
        'html.mm-opened body #cart .cart_item .item_info,html.mm-opening body #cart .cart_item .item_info{float:none!important;width:auto!important;min-width:0!important;margin:0!important;padding:2px 0 0!important;color:#4B403A!important;font-size:16px!important;line-height:1.35!important;font-weight:500!important;overflow-wrap:anywhere!important;word-break:normal!important;}',
        'html.mm-opened body #cart .cart_item .item_info .price,html.mm-opening body #cart .cart_item .item_info .price{margin-top:7px!important;font-size:17px!important;line-height:1.2!important;}',
        'html.mm-opened body #cart .cart_item>.mm-counter,html.mm-opening body #cart .cart_item>.mm-counter{order:2!important;position:static!important;float:none!important;width:auto!important;height:44px!important;margin:13px 0 0 102px!important;padding:0!important;border-radius:999px!important;}',
        'html.mm-opened body #cart .cart_item>.mm-counter .minus,html.mm-opening body #cart .cart_item>.mm-counter .minus,html.mm-opened body #cart .cart_item>.mm-counter .plus,html.mm-opening body #cart .cart_item>.mm-counter .plus{width:42px!important;height:42px!important;min-width:42px!important;min-height:42px!important;}',
        'html.mm-opened body #cart .cart_item>.mm-counter input.quantity,html.mm-opening body #cart .cart_item>.mm-counter input.quantity{width:46px!important;height:42px!important;min-width:46px!important;line-height:42px!important;font-size:15px!important;}',

        'html.mm-opened body #cart .mm-label,html.mm-opening body #cart .mm-label{margin-top:auto!important;padding:18px 20px 10px!important;background:#F3EEE4!important;border-top:1px solid #DED4C8!important;}',
        'html.mm-opened body #cart .mm-label .mm-counter.price,html.mm-opening body #cart .mm-label .mm-counter.price{position:static!important;float:right!important;margin:0!important;padding:0!important;}',
        'html.mm-opened body #cart .mm-subtitle.clearfix,html.mm-opening body #cart .mm-subtitle.clearfix{display:flex!important;flex-direction:column!important;gap:10px!important;width:100%!important;margin:0!important;padding:10px 20px max(20px,env(safe-area-inset-bottom))!important;background:#F3EEE4!important;border:0!important;box-sizing:border-box!important;}',
        'html.mm-opened body #cart .mm-subtitle.clearfix .action_button,html.mm-opening body #cart .mm-subtitle.clearfix .action_button,html.mm-opened body #cart .mm-subtitle.clearfix input.action_button[type="submit"],html.mm-opening body #cart .mm-subtitle.clearfix input.action_button[type="submit"],html.mm-opened body #cart .mm-subtitle.clearfix a.action_button.edit_cart,html.mm-opening body #cart .mm-subtitle.clearfix a.action_button.edit_cart{float:none!important;width:100%!important;max-width:none!important;height:52px!important;min-height:52px!important;margin:0!important;padding:0 18px!important;border-radius:8px!important;display:flex!important;align-items:center!important;justify-content:center!important;font-size:16px!important;line-height:1!important;text-align:center!important;box-sizing:border-box!important;}',
        'html.mm-opened body #cart .mm-subtitle.clearfix input.action_button[type="submit"],html.mm-opening body #cart .mm-subtitle.clearfix input.action_button[type="submit"]{order:1!important;background:#4B403A!important;color:#FFFEFB!important;border:1px solid #4B403A!important;}',
        'html.mm-opened body #cart .mm-subtitle.clearfix a.action_button.edit_cart,html.mm-opening body #cart .mm-subtitle.clearfix a.action_button.edit_cart{order:2!important;background:#FFFEFB!important;color:#4B403A!important;border:1px solid #D8CCBE!important;}',
        'html.mm-opened body #cart .empty_cart,html.mm-opening body #cart .empty_cart{flex:1 1 auto!important;display:flex!important;align-items:center!important;justify-content:center!important;min-height:260px!important;padding:40px 24px!important;background:#FCFAF2!important;}',
      '}',

      '@media only screen and (max-width:359px){',
          'html.mm-opened body #cart .cart_item,html.mm-opening body #cart .cart_item{padding-left:16px!important;padding-right:16px!important;}',
          'html.mm-opened body #cart .cart_item>a,html.mm-opening body #cart .cart_item>a{grid-template-columns:78px minmax(0,1fr)!important;gap:12px!important;}',
          'html.mm-opened body #cart .cart_item .cart_image,html.mm-opening body #cart .cart_item .cart_image{width:78px!important;height:102px!important;max-width:78px!important;}',
          'html.mm-opened body #cart .cart_item>.mm-counter,html.mm-opening body #cart .cart_item>.mm-counter{margin-left:90px!important;}',
      '}'
    ].join('');

    document.head.appendChild(style);
  }

  function clearMetrics() {
    root.style.removeProperty('--obfw-mobile-promo-height');
    root.style.removeProperty('--obfw-mobile-header-height');
    root.style.removeProperty('--obfw-mobile-header-stack');
  }

  function updateObserver(element, previous, key) {
    if (!resizeObserver || !element || element === previous) return;
    if (previous) resizeObserver.unobserve(previous);
    resizeObserver.observe(element);
    if (key === 'promo') observedPromo = element;
    if (key === 'header') observedHeader = element;
  }

  function measure() {
    ensureStyle();

    if (!mq.matches) {
      clearMetrics();
      return;
    }

    var promo = document.querySelector('.promo_banner');
    var header = document.getElementById('header');
    var promoHeight = promo ? Math.ceil(promo.getBoundingClientRect().height) : 0;
    var headerHeight = header ? Math.ceil(header.getBoundingClientRect().height) : 49;

    if (!headerHeight || headerHeight < 1) headerHeight = 49;

    root.style.setProperty('--obfw-mobile-promo-height', promoHeight + 'px');
    root.style.setProperty('--obfw-mobile-header-height', headerHeight + 'px');
    root.style.setProperty('--obfw-mobile-header-stack', (promoHeight + headerHeight) + 'px');

    updateObserver(promo, observedPromo, 'promo');
    updateObserver(header, observedHeader, 'header');
  }

  function getCartList() {
    var cart = document.getElementById('cart');
    return cart ? cart.querySelector('ul[data-money-format]') : null;
  }

  function getCartItemCount(list) {
    var total = 0;
    if (!list) return total;

    list.querySelectorAll('.cart_item input.quantity').forEach(function (input) {
      var value = parseInt(input.value || '0', 10);
      if (!isNaN(value)) total += value;
    });

    return total;
  }

  function decorateCartDrawer() {
    ensureStyle();

    var cart = document.getElementById('cart');
    var list = getCartList();
    if (!cart || !list) return;

    cart.setAttribute('aria-label', 'Shopping cart');

    var head = list.querySelector('li.mm-subtitle');
    if (!head) return;

    head.classList.add('obfw-cart-head');

    var heading = head.querySelector('.obfw-cart-heading');
    if (!heading) {
      heading = document.createElement('div');
      heading.className = 'obfw-cart-heading';
      heading.innerHTML =
        '<span class="obfw-cart-eyebrow">Wholesale order</span>' +
        '<span class="obfw-cart-title">Shopping Cart</span>' +
        '<span class="obfw-cart-count"></span>';
      head.insertBefore(heading, head.firstChild);
    }

    var closeLink = head.querySelector('.continue');
    if (closeLink) closeLink.setAttribute('aria-label', 'Close shopping cart');

    var count = getCartItemCount(list);
    var countText = count === 1 ? '1 item' : count + ' items';
    var countEl = heading.querySelector('.obfw-cart-count');
    if (countEl && countEl.textContent !== countText) {
      countEl.textContent = countText;
    }

    if (observedCartList !== list && 'MutationObserver' in window) {
      if (cartObserver) cartObserver.disconnect();
      cartObserver = new MutationObserver(function () {
        window.requestAnimationFrame(decorateCartDrawer);
      });
      cartObserver.observe(list, { childList: true, subtree: true });
      observedCartList = list;
    }
  }

  function scheduleMeasure() {
    window.requestAnimationFrame(measure);
  }

  function scheduleCartDecorate() {
    window.requestAnimationFrame(decorateCartDrawer);
  }

  if ('ResizeObserver' in window) {
    resizeObserver = new ResizeObserver(scheduleMeasure);
  }

  ensureStyle();
  scheduleMeasure();
  scheduleCartDecorate();

  document.addEventListener('DOMContentLoaded', function () {
    scheduleMeasure();
    scheduleCartDecorate();
  });

  window.addEventListener('load', function () {
    scheduleMeasure();
    scheduleCartDecorate();
  });

  window.addEventListener('resize', scheduleMeasure);
  window.addEventListener('orientationchange', function () {
    scheduleMeasure();
    scheduleCartDecorate();
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('.cart-button, a[href="#cart"]')) {
      window.setTimeout(scheduleCartDecorate, 0);
      window.setTimeout(scheduleCartDecorate, 80);
    }
  });

  if (mq.addEventListener) {
    mq.addEventListener('change', function () {
      scheduleMeasure();
      scheduleCartDecorate();
    });
  } else if (mq.addListener) {
    mq.addListener(function () {
      scheduleMeasure();
      scheduleCartDecorate();
    });
  }

  window.setTimeout(function () {
    scheduleMeasure();
    scheduleCartDecorate();
  }, 50);

  window.setTimeout(function () {
    scheduleMeasure();
    scheduleCartDecorate();
  }, 250);

  window.setTimeout(function () {
    scheduleMeasure();
    scheduleCartDecorate();
  }, 750);
})();
